import moment from 'moment'
const Formatter = {
    toLocalString: (value) => {
        return moment(value).local().format('DD-MM-YYYY HH:mm')
    },
    toLocalDateString: (value) => {
        return moment(value).local().format('DD-MM-YYYY')
    },
    dateToUnixTimestamp: (time) => {
        var date = new Date(time)
        return Math.floor(date.getTime() / 1000);
    },
    unixTimestampToDate: (unixTimestamp) => {
        return new Date(unixTimestamp * 1000);
    }
}
export default {
    Formatter
}
